$(document).ready(function () {
    let ckeditors = {};
    const $modal = $('#formModal');
    const $form = $('#modalForm');
    const $title = $('#modalTitle');
    const $method = $form.find('input[name="_method"]');
    const $registroId = $('#registro_id');
    const $formFields = $('#formFields');
    const tipo = $('.gestor-wrapper').data('tipo'); // Asume que pasas el tipo como <body data-tipo="promociones">
    $('#submitBtn').on('click', function () {
        $('.form-error').text('');
        $('input, select, textarea').removeClass('is-invalid');
        $form.trigger('submit');
    });


    // Abrir modal para nuevo (vía fetch de campos y relaciones)
    $('#openCreateModal').on('click', function (e) {
        e.preventDefault();

        $.get(`/admin/gestionar/${tipo}/create`, function (data) {
            openModal('create', data);
        });
    });
    // Cerrar modal
    $('#closeModal').on('click', function () {
        if ($form[0]) {
            $form[0].reset();
        }

        // 🧹 CKEditor 5: destruir instancias al cerrar el modal
        for (const id in ckeditors) {
            if (ckeditors[id]) {
                ckeditors[id].destroy().catch(error => console.error(error));
            }
        }
        ckeditors = {};

        $('.form-error').text('');
        $formFields.empty();
        $modal.addClass('hidden');
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $modal.addClass('hidden');
        }
    });
    // Abrir modal para editar (con datos vía fetch)
    $('.openEditModal').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');

        $.get(`/admin/gestionar/${tipo}/${id}/edit`, function (data) {
            openModal('edit', data);
        });
    });
    // Drag & Drop + Preview
    const dropArea = $('#dropArea');
    const input = $('#imagenInput');
    const preview = $('#previewImage');
    const dropText = $('#dropText');
    dropArea.on('dragover', function (e) {
        e.preventDefault();
        dropArea.addClass('dragover');
    });
    dropArea.on('dragleave', function () {
        dropArea.removeClass('dragover');
    });
    dropArea.on('drop', function (e) {
        e.preventDefault();
        dropArea.removeClass('dragover');
        const file = e.originalEvent.dataTransfer.files[0];
        input[0].files = e.originalEvent.dataTransfer.files;
        showPreview(file);
    });
    input.on('change', function () {
        const file = this.files[0];
        showPreview(file);
    });
    $form.on('submit', function (e) {
        e.preventDefault();

        // 1) Volcar SIEMPRE el HTML de cada editor al <textarea> antes de crear FormData
        for (const name in ckeditors) {
            if (!ckeditors[name]) continue;
            const html = ckeditors[name].getData();
            $(`textarea[name="${name}"]`).val(html);
        }

        // 2) FormData con el <form> (asegúrate de que #formFields está DENTRO del <form>)
        const formEl = this; // #modalForm
        const formData = new FormData(formEl);

        // --- DEBUG: ver qué estás enviando ---
        console.log('FORM KEYS =>', [...formData.keys()]);
        if (formData.has('descripcion')) {
            console.log('DESCRIPCION =>', (formData.get('descripcion') || '').slice(0, 400));
        }
        // -------------------------------------

        const action = $form.attr('action');
        const method = $method.val();

        $('.form-error').text('');

        $.ajax({
            url: action,
            method: method === 'PUT' ? 'POST' : method,
            data: formData,
            contentType: false,
            processData: false,
            headers: method === 'PUT' ? { 'X-HTTP-Method-Override': 'PUT' } : {},
            success: function (response) {
                if (response.redirect && response.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: response.success,
                        confirmButtonColor: '#2563eb'
                    }).then(() => {
                        window.location.href = response.redirect;
                    });
                    $modal.addClass('hidden');
                } else {
                    location.reload();
                }
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    const errors = xhr.responseJSON.errors;
                    for (const field in errors) {
                        const $input = $(`[name="${field}"]`);
                        $input.addClass('is-invalid');
                        $(`#${field}Error`).text(errors[field][0]);
                    }
                } else if (xhr.status === 500) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.',
                        confirmButtonColor: '#2563eb'
                    });
                }
            }
        });
    });


    $('.deleteRecord').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');
        const tipo = $('.gestor-wrapper').data('tipo');
    
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/gestionar/${tipo}/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    }); 
    //Filtro
    const searchInput = document.getElementById('searchInput');
    const searchSelect = document.getElementById('searchField');
    if(searchInput && searchSelect){
        //searchInput.addEventListener('input', () => {
        //    clearTimeout(window.searchDelay);
        //    window.searchDelay = setTimeout(updateSearch, 1500);
        //});
    
        searchSelect.addEventListener('change', updateSearch);
    }
    //Modal cupones
    const cuponModal = document.getElementById('cuponModal');
    const closeCuponModal = document.getElementById('closeCuponModal');
    //Generar cupones en gestor
    document.querySelectorAll('.generarCuponesBtn').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.id;
            document.getElementById('cuponModal_elemento_id').value = id;
            cuponModal.classList.remove('hidden');
        });
    });
    //Generar cupones en cupones
    document.querySelectorAll('.generarCuponesBtn2').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.relacionado;
            const tipo = btn.dataset.tipo;
            document.getElementById('cuponModal_elemento_id').value = id;
            document.getElementById('cuponModal_tipo').value = tipo;
            cuponModal.classList.remove('hidden');
        });
    });
    if(closeCuponModal){
        closeCuponModal.addEventListener('click', () => {
            cuponModal.classList.add('hidden');
        });
    }


    function activarDropArea(field) {
        const input = $(`#imagenInput-${field}`);
        const preview = $(`#previewImage-${field}`);
        const dropArea = $(`#dropArea-${field}`);
        const dropText = $(`#dropText-${field}`);
    
        if (dropArea.length && input.length) {
            dropArea.on('dragover', function (e) {
                e.preventDefault();
                dropArea.addClass('dragover');
            });
    
            dropArea.on('dragleave', function () {
                dropArea.removeClass('dragover');
            });
    
            dropArea.on('drop', function (e) {
                e.preventDefault();
                dropArea.removeClass('dragover');
                const file = e.originalEvent.dataTransfer.files[0];
                input[0].files = e.originalEvent.dataTransfer.files;
                showPreview(file, preview, dropText);
            });
    
            input.on('change', function () {
                const file = this.files[0];
                showPreview(file, preview, dropText);
            });
        }
    }
    function showPreview(file, previewEl, textEl, infoEl = null) {
        if (!file) return;

        // reset
        if (previewEl && previewEl.length) previewEl.hide().attr('src', '');
        if (infoEl && infoEl.length) infoEl.hide().text('');
        if (textEl && textEl.length) textEl.hide();

        const type = file.type || '';
        const isImage = type.startsWith('image/');

        // info común si hay infoEl
        if (infoEl && infoEl.length) {
            const sizeKB = (file.size / 1024).toFixed(1);
            let icon = '📄';
            const name = (file.name || '').toLowerCase();
            if (name.endsWith('.pdf')) icon = '📕';
            else if (name.endsWith('.zip') || name.endsWith('.rar')) icon = '🗜️';
            else if (name.endsWith('.doc') || name.endsWith('.docx')) icon = '📝';
            else if (isImage) icon = '🖼️';

            infoEl
                .html(`${icon} <strong>${file.name || 'archivo'}</strong> · ${sizeKB} KB · <code>${type || 'desconocido'}</code>`)
                .show();
        }

        // si es imagen, mostramos miniatura
        if (isImage && previewEl && previewEl.length) {
            const reader = new FileReader();
            reader.onload = function (e) {
                previewEl.attr('src', e.target.result).show();
            };
            reader.readAsDataURL(file);
        }
    }

    function updateSearch() {
        const q = searchInput.value.trim();
        const field = searchSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set('q', q);
        url.searchParams.set('field', field);

        window.location.href = url.toString();
    }
    function openModal(mode, data = {}) {
        $modal.removeClass('hidden');
        $title.text(mode === 'edit' ? 'Editar registro' : 'Nuevo registro');
        $method.val(mode === 'edit' ? 'PUT' : 'POST');
        $registroId.val(data.id || '');

        $form.attr('action', mode === 'edit'
            ? `/admin/gestionar/${tipo}/${data.id}`
            : `/admin/gestionar/${tipo}`
        );

        // Mostrar loader con fade-in
        $('#modalLoader').removeClass('hidden').addClass('show');
        $formFields.removeClass('show').addClass('hidden');

        setTimeout(() => {
            renderFields(mode, data);
    
            // Ocultar loader y mostrar campos con fade
            $('#modalLoader').removeClass('show').addClass('fade');
            setTimeout(() => {
                $('#modalLoader').css('display', 'none');
                $formFields.removeClass('hidden').addClass('show');
            }, 300);
        }, 300);
    }
    const paginasDisponibles = [
        { value: '/', label: 'Página principal (home)' },
        { value: 'tiendas', label: 'Tiendas' },
        { value: 'promociones-tiendas', label: 'Promociones' },
        { value: 'horarios-aperturas', label: 'Horarios/Aperturas' },
        { value: 'donde-comer', label: 'Donde comer' },
        { value: 'ocio-infantil', label: 'Ocio Infantil' },
        { value: 'actividades-agenda', label: 'Actividades/Agenda' },
        { value: 'zona-descargas', label: 'Descarga tus fotos o videos' },
        { value: 'nuestro-centro', label: 'Nuestro centro' },
        { value: 'servicios', label: 'Servicios' }
    ];
    function renderFields(mode, data) {
        if (tipo === 'files') {
            const html = `
                <div class="form-group">
                    <label>Archivo</label>
                    <div class="drop-area" id="dropArea-archivo">
                        <span id="dropText-archivo">Haz clic o arrastra un archivo aquí</span>
                        <input type="file" name="archivo" id="imagenInput-archivo" />
                        <img class="previewImage" id="previewImage-archivo" style="display:none; max-width:100%; height:auto; margin-top:.5rem;">
                        <div id="fileInfo-archivo" style="margin-top:.5rem; display:none; font-size:.9rem;"></div>
                    </div>
                    <div class="form-error" id="archivoError"></div>
                </div>
            `;
            $formFields.html(html);

            setTimeout(() => {
                const input    = $('#imagenInput-archivo');
                const preview  = $('#previewImage-archivo');
                const dropArea = $('#dropArea-archivo');
                const dropText = $('#dropText-archivo');
                const infoEl   = $('#fileInfo-archivo');

                dropArea.on('dragover', e => { e.preventDefault(); dropArea.addClass('dragover'); });
                dropArea.on('dragleave', () => dropArea.removeClass('dragover'));
                dropArea.on('drop', e => {
                    e.preventDefault();
                    dropArea.removeClass('dragover');
                    const file = e.originalEvent.dataTransfer.files?.[0];
                    if (!file) return;
                    // reflejar en el input
                    const dt = new DataTransfer();
                    dt.items.add(file);
                    input[0].files = dt.files;
                    showPreview(file, preview, dropText, infoEl);
                });
                input.on('change', function () {
                    const file = this.files?.[0];
                    showPreview(file, preview, dropText, infoEl);
                });
            }, 50);

            return; // no sigas con el generador genérico
        }

        const campos = (data._fields || []).filter(f => f !== 'baner');
        const relaciones = data._relaciones || {};
        let html = '';
        //Campo banner
        if (['tiendas', 'eventos', 'promociones'].includes(tipo)) {
            const baner = data.baner || {};
            html += `
                <div class="form-group">
                    <label>Imagen de cabecera</label>
                    <div class="drop-area" id="dropArea-baner_imagen">
                        <span id="dropText-baner_imagen">Haz clic o arrastra una imagen aquí</span>
                        <input type="file" name="baner_imagen" id="imagenInput-baner_imagen" accept="image/*">
                        <img class="previewImage" id="previewImage-baner_imagen" src="${baner.imagen_url || ''}" style="display:${baner.imagen_url ? 'block' : 'none'};">
                    </div>
                    <div class="form-error" id="baner_imagenError"></div>
                </div>
                <div class="form-group" style="display:none;">
                    <label>Orden del banner</label>
                    <input type="number" name="baner_orden" value="${baner.orden || 0}">
                </div>
                <div class="form-group switch-group">
                    <label>Cabecera Activa</label>
                    <label class="switch">
                        <input type="checkbox" name="baner_activo" ${baner.activo ? 'checked' : ''}>
                        <span class="slider"></span>
                    </label>
                </div>
                <input type="hidden" name="baner_id" value="${baner.id || ''}">
            `;
        }
        delete data.baner;
        campos.forEach(field => {
            const label = field.replace('_id', '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            let valor = data[field] ?? '';
            const key = field.endsWith('_id') ? field : `${field}_id`;
            //Campo imagen
            if (field.includes('imagen') || field.includes('logo') || field.includes('mapa_planta0') || field.includes('mapa_plantam1') || field.includes('image')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <div class="drop-area" id="dropArea-${field}">
                            <span id="dropText-${field}">Haz clic o arrastra una imagen aquí</span>
                            <input type="file" name="${field}" id="imagenInput-${field}" accept="image/*">
                            <img class="previewImage" id="previewImage-${field}" src="${valor || ''}" alt="Vista previa" style="display:${valor ? 'block' : 'none'};">
                        </div>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            //Campo select
            } else if (field.endsWith('_id')) {
                if(field === 'user_id' && (tipo === 'tiendas' || tipo === 'locales')){
                    const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                    html += `
                        <div class="form-group">
                            <label>${label}</label>
                            <select name="${field}" class="select2-init">
                                <option value="">Selecciona una opción</option>
                                ${relacion.map(rel => `
                                    <option value="${rel.id}" ${rel.id == valor ? 'selected' : ''}>
                                        ${ (rel.nif_cif ? rel.nif_cif + ' - ' : '') + (rel.name || '') }
                                    </option>
                                `).join('')}
                            </select>
                        </div>
                    `;
                }else if(field === 'tienda_id' && tipo === 'locales'){
                    const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                    html += `
                        <div class="form-group">
                            <label>${label}</label>
                            <select name="${field}" class="select2-init">
                                <option value="">Selecciona una opción</option>
                                ${relacion.map(rel => `
                                    <option value="${rel.id}" ${rel.id == valor ? 'selected' : ''}>
                                        ${rel.nombre || rel.name || rel.titulo || rel.id}
                                    </option>
                                `).join('')}
                            </select>
                        </div>
                    `;
                }else{
                    const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                    html += `
                        <div class="form-group">
                            <label>${label}</label>
                            <select name="${field}">
                                <option value="">Selecciona una opción</option>
                                ${relacion.map(rel => `
                                    <option value="${rel.id}" ${rel.id == valor ? 'selected' : ''}>
                                        ${rel.nombre || rel.name || rel.titulo || rel.id}
                                    </option>
                                `).join('')}
                            </select>
                        </div>
                    `;
                }
            //Campo text area
            } else if (field.includes('descripcion')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field.includes('meta_description')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field.includes('html_adicional')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            //Campo fecha
            } else if (field.includes('fecha') || field.includes('fecha_inicio') || field.includes('fecha_fin')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <input type="date" name="${field}" value="${valor}">
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field == 'id' || field == 'email_verified_at' || field == 'password' || field == 'remember_token' || field == 'reset_token') { 
                return;
            //Campo checkbox
            } else if (field.includes('activo')) {
                html += `
                    <div class="form-group switch-group">
                        <label>Elemento ${label}</label>
                        <label class="switch">
                            <input type="checkbox" name="${field}" ${valor == 1 ? 'checked' : ''}>
                            <span class="slider"></span>
                        </label>
                    </div>
                `;             
            //Campo checkbox
            } else if (field === 'destacado') {
                html += `
                    <div id="field_destacado">
                        <div class="form-group switch-group">
                            <label>Elemento ${label}</label>
                            <label class="switch">
                                <input type="checkbox" name="destacado" ${valor == 1 ? 'checked' : ''}>
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                `;
                // Campo adicional para páginas destacadas
                setTimeout(() => {
                    const checkbox = $form.find('input[name="destacado"]');
                    const paginasSeleccionadas = data.paginas_destacadas || [];

                    function togglePaginasField() {
                        if (checkbox.prop('checked')) {
                            renderPaginasDestacadasField(paginasSeleccionadas);
                        } else {
                            $('#field_paginas_destacadas').remove();
                        }
                    }
                    checkbox.on('change', togglePaginasField);
                    if (checkbox.prop('checked')) togglePaginasField();
                }, 100);       
            //Campo multiselect
            } else if (Array.isArray(valor)) {
                const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <select name="${field}[]" multiple>
                            ${relacion.map(rel => `
                                <option value="${rel.id}" ${valor.includes(rel.id) ? 'selected' : ''}>
                                    ${rel.nombre || rel.titulo || rel.id}
                                </option>
                            `).join('')}
                        </select>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field === 'paginas_destacadas') {
                return;
            } else if (field === 'locales' && tipo === 'tiendas') {
                return; // Ocultar campo locales para tiendas
            } else if (field === 'horario' && tipo === 'tiendas') {
                return; // Ocultar campo horario para tiendas
            } else {
                const isDatoReadOnly = (tipo === 'corporativo' && field === 'dato') ? 'readonly' : '';
                if(tipo === 'corporativo' && valor.length >  100){
                    html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                    `;
                } else {
                    if(field === 'planta') {
                        html += `
                             <div class="form-group">
                                <label>${label}</label>
                                <select name="${field}">
                                    <option value="">Selecciona una opción</option>
                                    <option ${valor == '0' ? 'selected' : ''} value="0">Planta 0</option>
                                    <option ${valor == '-1' ? 'selected' : ''} value="-1">Planta -1</option>
                                    <option ${valor == 'ambas' ? 'selected' : ''} value="ambas">Ambas</option>
                                </select>
                            </div>
                        `;
                    }else{
                        html += `
                            <div class="form-group">
                                <label>${label}</label>
                                <input type="text" name="${field}" value="${valor}" ${isDatoReadOnly}>
                                <div class="form-error" id="${field}Error"></div>
                            </div>
                        `;
                    }
                }
            }
        });

        if (mode === 'edit') {
            Object.entries(data).forEach(([key, value]) => {
                // Mostrar solo si es un array de objetos y NO es una relación many-to-many
                if (Array.isArray(value) && value.length && typeof value[0] === 'object') {
                    // Evitar repetir las relaciones many-to-many que ya están en campos
                    if (!campos.includes(key)) {
                        html += `
                            <div class="form-group">
                                <label>${key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</label>
                                <ul>
                                    ${value.map(item => {
                                        const preview = item.numero_local || item.nombre || item.titulo || item.id;
                                        const extra = item.planta ? ` (Planta ${item.planta})` : '';
                                        return `<li>${preview}${extra}</li>`;
                                    }).join('')}
                                </ul>
                            </div>
                        `;
                    }
                }
            });
        }
        setTimeout(() => {
            // Inicializa drag and drop para cada campo de imagen
            $('[type="file"][accept*="image"]').each(function () {
                const input = $(this);
                const field = input.attr('name');
                const dropArea = $(`#dropArea-${field}`);
                const preview = $(`#previewImage-${field}`);
                const dropText = $(`#dropText-${field}`);
        
                dropArea.on('dragover', function (e) {
                    e.preventDefault();
                    dropArea.addClass('dragover');
                });
        
                dropArea.on('dragleave', function () {
                    dropArea.removeClass('dragover');
                });
        
                dropArea.on('drop', function (e) {
                    e.preventDefault();
                    dropArea.removeClass('dragover');
                    const file = e.originalEvent.dataTransfer.files[0];
                    input[0].files = e.originalEvent.dataTransfer.files;
                    showPreview(file, preview, dropText);
                });
        
                input.on('change', function () {
                    const file = this.files[0];
                    showPreview(file, preview, dropText);
                });
            });
        }, 100);
        
        $formFields.html(html);
        setTimeout(() => {
            reiniciarCKEditor();
            initSelect2();
        }, 100);

    }
    activarDropArea('logo');
    activarDropArea('baner');

    function renderPaginasDestacadasField(selected = []) {
        const html = `
            <div class="form-group" id="field_paginas_destacadas">
                <label>Páginas donde destacar</label>
                <select name="paginas_destacadas[]" multiple class="form-control">
                    ${paginasDisponibles.map(p => `
                        <option value="${p.value}" ${selected.includes(p.value) ? 'selected' : ''}>
                            ${p.label}
                        </option>
                    `).join('')}
                </select>
                <div class="form-error" id="paginas_destacadasError"></div>
            </div>
        `;
        $('#field_destacado').append(html);
    }
    function initSelect2() {
        if ($.fn.select2) {
            console.log('Initializing Select2 for', $('.select2-init').length, 'elements');
            $('.select2-init').each(function() {
                $(this).select2({
                    width: '100%',
                    placeholder: 'Selecciona una opción',
                    allowClear: true,
                    dropdownParent: $('#formModal'),
                    minimumResultsForSearch: 0 // Force search box visibility
                }).removeClass('select2-init').addClass('select2-active');
            });
        } else {
            console.warn('Select2 library not found!');
        }
    }
    async function reiniciarCKEditor() {
        // 1) Destruye editores previos
        const vivos = Object.values(ckeditors || {});
        if (vivos.length) await Promise.allSettled(vivos.map(ed => ed.destroy()));
        ckeditors = {};

        // 2) Inicializa SOLO los textarea ricos visibles
        const areas = Array.from(document.querySelectorAll(
            'textarea[name*="descripcion"], textarea[name*="contenido"], textarea[name*="valor"]'
        )).filter(t => t.offsetParent !== null);

        for (const textarea of areas) {
            if (textarea.dataset.ckInit === '1') continue;
            textarea.dataset.ckInit = '1';

            const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            const storageKey = `ckauto:${location.pathname}:${textarea.name}:${$('#registro_id').val() || 'nuevo'}`;

            // ⬇️ super-build expone CKEDITOR.ClassicEditor; fallback a ClassicEditor si hiciera falta
            const EditorCtor = (window.CKEDITOR && CKEDITOR.ClassicEditor) || window.ClassicEditor;

            const editor = await EditorCtor.create(textarea, {
                toolbar: {
                    shouldNotGroupWhenFull: true,
                    items: [
                        'undo','redo','|',
                        'heading','|',
                        'bold','italic','underline','strikethrough','subscript','superscript','|',
                        'fontSize','fontFamily','fontColor','fontBackgroundColor','|',
                        'alignment','outdent','indent','horizontalLine','|',
                        'bulletedList','numberedList','todoList','|',
                        'link','blockQuote','code','codeBlock','|',
                        'insertTable','imageUpload','mediaEmbed','htmlEmbed','|',
                        'findAndReplace','removeFormat',
                        // si NO quieres que toquen HTML crudo, elimina 'sourceEditing'
                        'sourceEditing'
                    ]
                },

                heading: {
                    options: [
                        { model: 'paragraph', title: 'Párrafo', class: 'ck-heading_paragraph' },
                        { model: 'heading2', view: 'h2', title: 'H2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'H3', class: 'ck-heading_heading3' },
                        { model: 'heading4', view: 'h4', title: 'H4', class: 'ck-heading_heading4' }
                    ]
                },

                fontSize: { options: ['tiny','small','default','big','huge'] },
                alignment: { options: ['left','center','right','justify'] },

                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    decorators: {
                        openInNewTab: {
                            mode: 'manual', label: 'Abrir en nueva pestaña',
                            attributes: { target: '_blank', rel: 'noopener noreferrer' }
                        },
                        nofollow: {
                            mode: 'manual', label: 'Marcar como nofollow',
                            attributes: { rel: 'nofollow' }
                        }
                    }
                },

                // Subida de imágenes (tu endpoint Laravel)
                ckfinder: { uploadUrl: `/admin/ckeditor/upload?_token=${encodeURIComponent(token)}` },

                // Imágenes: estilos + resize + caption
                image: {
                    toolbar: [
                        'imageTextAlternative','toggleImageCaption','linkImage','|',
                        'imageStyle:inline','imageStyle:block','imageStyle:side','|',
                        'resizeImage'
                    ],
                    styles: ['inline','block','side'],
                    resizeUnit: '%',
                    resizeOptions: [
                        { name: 'resizeImage:original', label: 'Original', value: null },
                        { name: 'resizeImage:25', label: '25%', value: '25' },
                        { name: 'resizeImage:50', label: '50%', value: '50' },
                        { name: 'resizeImage:75', label: '75%', value: '75' },
                        { name: 'resizeImage:100', label: '100%', value: '100' }
                    ]
                },

                // Tablas avanzadas
                table: {
                    contentToolbar: [
                        'tableColumn','tableRow','mergeTableCells',
                        'tableCellProperties','tableProperties'
                    ]
                },

                mediaEmbed: { previewsInData: true },
                htmlEmbed: { showPreviews: true },

                // Contador palabras/caracteres
                wordCount: {
                    onUpdate: stats => {
                        let box = textarea.parentElement.querySelector('.ck-wordcount');
                        if (!box) {
                            box = document.createElement('div');
                            box.className = 'ck-wordcount';
                            box.style.cssText = 'font-size:.85rem;color:#6b7280;margin-top:.25rem;';
                            textarea.parentElement.appendChild(box);
                        }
                        box.textContent = `Palabras: ${stats.words} · Caracteres: ${stats.characters}`;
                    }
                },

                // Autosave local (evita pérdidas)
                autosave: {
                    waitingTime: 800,
                    save(editor) {
                        try { localStorage.setItem(storageKey, editor.getData()); } catch(_) {}
                    }
                },

                // Quita plugins cloud/collab que no usas (evita warnings en consola)
                removePlugins: [
                    'CKBox','EasyImage','WProofreader',
                    'RealTimeCollaborativeComments','RealTimeCollaborativeTrackChanges',
                    'RealTimeCollaborativeRevisionHistory','PresenceList','Comments',
                    'TrackChanges','TrackChangesData','RevisionHistory','MathType','Pagination',
                    'DocumentOutline',
                    'AIAssistant',               // ai-invalid-license-key
                    'MultiLevelList',            // multi-level-list-invalid-license-key
                    'TableOfContents',           // table-of-contents-invalid-license-key
                    'FormatPainter',             // format-painter-invalid-license-key
                    'Template',                 // template-invalid-license-key
                    'SlashCommand',              // slash-command-invalid-license-key
                    'PasteFromOfficeEnhanced',   // paste-from-office-enhanced-invalid-license-key
                    'CaseChange',                // case-change-invalid-license-key
                    'DocumentOutline'            // (además, evitamos el error del índice de documento)
                    // OJO: no quites CKFinder si usas uploadUrl
                ]
            });

            // 3) Restaura borrador local si el textarea está vacío
            const cached = localStorage.getItem(storageKey);
            if (cached && !textarea.value) editor.setData(cached);

            // 4) Guarda referencia
            ckeditors[textarea.name] = editor;

            // 5) Limpia autosave al enviar/cerrar
            $form.on('submit', () => { try { localStorage.removeItem(storageKey); } catch(_) {} });
            $('#closeModal').one('click', () => { try { localStorage.removeItem(storageKey); } catch(_) {} });
        }
    }





    $(document).on('click', '.btn-toggle-estado', function () {
        const id = $(this).data('id');
        const modelo = $(this).data('modelo');
        const boton = $(this);

        $.get(`/admin/gestionar/${modelo}/toggle-estado/${id}`, function (response) {
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'El estado del registro ha sido actualizado.',
                    confirmButtonColor: '#2563eb'
                });
                window.location.reload();
            } else {
                alert('Error: ' + response.message);
            }
        });
    });



});


window.CKTOOLS = window.CKTOOLS || {
  editors: {},
  // selector: qué textareas inicializar, por defecto .ckeditor
  async init(selector = '.ckeditor') {
    // Destruye instancias vivas (opcional si solo inicializas una vez por página)
    await Promise.allSettled(Object.values(this.editors).map(ed => ed?.destroy?.()));
    this.editors = {};

    const EditorCtor = (window.CKEDITOR && CKEDITOR.ClassicEditor) || window.ClassicEditor;
    if (!EditorCtor) {
      console.warn('CKEditor no está cargado aún');
      return;
    }

    const areas = Array.from(document.querySelectorAll(selector))
      .filter(t => t.offsetParent !== null); // evita ocultos

    for (const textarea of areas) {
      if (textarea.dataset.ckInit === '1') continue;
      textarea.dataset.ckInit = '1';

      const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
      const pageKey = (document.querySelector('#registro_id')?.value) || 'page';
      const storageKey = `ckauto:${location.pathname}:${textarea.name || textarea.id || 'no-name'}:${pageKey}`;

      const editor = await EditorCtor.create(textarea, {
        toolbar: {
          shouldNotGroupWhenFull: true,
          items: [
            'undo','redo','|','heading','|',
            'bold','italic','underline','strikethrough','|',
            'bulletedList','numberedList','|',
            'link','blockQuote','insertTable','imageUpload','htmlEmbed','|',
            'alignment','outdent','indent','horizontalLine','|',
            'removeFormat'
          ]
        },
        alignment: { options: ['left','center','right','justify'] },
        ckfinder: token ? { uploadUrl: `/admin/ckeditor/upload?_token=${encodeURIComponent(token)}` } : undefined,
        image: { toolbar: ['imageTextAlternative','toggleImageCaption','linkImage','|','imageStyle:inline','imageStyle:block','imageStyle:side','|','resizeImage'] },
        mediaEmbed: { previewsInData: true },
        removePlugins: [
          'CKBox','EasyImage','WProofreader',
          'RealTimeCollaborativeComments','RealTimeCollaborativeTrackChanges',
          'RealTimeCollaborativeRevisionHistory','PresenceList','Comments',
          'TrackChanges','TrackChangesData','RevisionHistory','MathType','Pagination',
          'DocumentOutline','AIAssistant','MultiLevelList','TableOfContents',
          'FormatPainter','Template','SlashCommand','PasteFromOfficeEnhanced','CaseChange'
        ]
      });

      // Restaura borrador local si el textarea está vacío
      const cached = localStorage.getItem(storageKey);
      if (cached && !textarea.value) editor.setData(cached);

      // Guarda referencia
      this.editors[textarea.name || textarea.id || `ta-${Math.random()}`] = editor;

      // Limpia autosave al enviar formularios tradicionales
      const formEl = textarea.closest('form');
      if (formEl) formEl.addEventListener('submit', () => { try { localStorage.removeItem(storageKey); } catch(_) {} });
    }
  },

  async destroyAll() {
    const edits = Object.values(this.editors);
    await Promise.allSettled(edits.map(async (ed) => {
        try {
        const ta = ed?.sourceElement;
        await ed?.destroy?.();
        if (ta) {
            // 🔑 Quita marcas para permitir re-inicializar al reabrir
            delete ta.dataset.ckInit;
            ta.removeAttribute('data-ck-init');
            ta.removeAttribute('data-ckeditor');
        }
        } catch (e) {
        console.warn(e);
        }
    }));
    this.editors = {};
}

};
CKTOOLS.init('.ckeditor');